export default "__VITE_ASSET__DgEiBy1J__"